import utils from './utils'

const hire = (project) => {
  return [
    utils.rateTable({
      unitType: 'time',
    }),
  ]
}

export default hire